// extracted by mini-css-extract-plugin
export default {"triangleList":"TriangleSingleItemLayout_triangleList__LtCnX"};